import React from "react";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { MoneyCellRenderer } from "~/pages/Billing/components/MoneyCellRenderer";
import { GRID_COLUMN_FILTER_DEBOUNCE_MS } from "~/pages/Billing/constants";
import {
  cellFlexCenter,
  cellRightAlign,
  entityNameCell,
  warningTextCell,
  warningIcon,
} from "./styles_vanilla.css";
import type { EntityRowItem } from "./types";
import type { ColDef, ICellRendererParams } from "ag-grid-community";

export const EntityNameCellRenderer = (
  params: ICellRendererParams<EntityRowItem>,
): React.ReactNode => {
  const entityName = params.data?.entityName ?? "";
  return (
    <>
      <Icon
        type="exclamation-triangle"
        color={Colors.Warning600}
        variant="outline"
        className={warningIcon}
      />
      <span className={entityNameCell}>{entityName}</span>
    </>
  );
};

export const EumCellRenderer = (
  params: ICellRendererParams<EntityRowItem>,
): React.ReactElement | string => {
  return MoneyCellRenderer({
    value: params.value as number | null | undefined,
    rounded: true,
  });
};

export const getColumnDefinitions = (): ColDef<EntityRowItem>[] => [
  {
    field: "entityName",
    headerName: "Entity",
    cellRenderer: EntityNameCellRenderer,
    cellClass: cellFlexCenter,
    flex: 2,
    sortable: true,
    filter: "agTextColumnFilter",
    filterParams: {
      filterOptions: ["contains"],
      maxNumConditions: 1,
      debounceMs: GRID_COLUMN_FILTER_DEBOUNCE_MS,
    },
  },
  {
    field: "softwareEumUsd",
    headerName: "Software EUM",
    cellRenderer: EumCellRenderer,
    cellClass: cellRightAlign,
    flex: 1,
    sortable: true,
    filter: false,
  },
  {
    field: "billableFaEumUsd",
    headerName: "Billable FA EUM",
    cellRenderer: EumCellRenderer,
    cellClass: cellRightAlign,
    flex: 1,
    sortable: true,
    filter: false,
  },
  {
    field: "entityId",
    headerName: "Entity ID",
    flex: 1,
    sortable: true,
    cellClass: cellRightAlign,
    filter: "agTextColumnFilter",
    filterParams: {
      filterOptions: ["contains"],
      maxNumConditions: 1,
      debounceMs: GRID_COLUMN_FILTER_DEBOUNCE_MS,
    },
  },
  {
    field: "jsqProductLine",
    headerName: "JSQ product line",
    flex: 1,
    sortable: true,
    filter: false,
    valueFormatter: (params) => (typeof params.value === "string" ? params.value : "-"),
  },
  {
    field: "billingStatus",
    headerName: "Billing status",
    flex: 1,
    sortable: true,
    filter: false,
    cellClass: warningTextCell,
  },
];
